import VueGapi from 'vue-gapi'

const clientConfig = {
    apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    discoveryDocs: [process.env.VUE_APP_GOOGLE_DISCOVERY_DOCS],
    scope: process.env.VUE_APP_GOOGLE_SCOPES,
    refreshToken: true,
}

function Gapi() {}
let vgapi = new Gapi()

export default {
    async configure() {
        if (!vgapi.$gapi) {
            VueGapi.install(Gapi, clientConfig)
        }
    },
    isSignedInGoogle() {
        return vgapi.$gapi.getGapiClient().then((gapi) => {
            return gapi.auth2.getAuthInstance().then((oauth) => {
                return oauth.currentUser.get().isSignedIn()
            })
        })
    },
    googleLogin() {
        return vgapi.$gapi.getGapiClient().then((gapi) => {
            return gapi.auth2.getAuthInstance().signIn()
        })
    },
    googleLogout() {
        vgapi.$gapi.getGapiClient().then((gapi) => {
            gapi.auth2.getAuthInstance().disconnect()
        })
    },
    getGoogleContacts() {
        return this.isSignedInGoogle(() => {}).then((isSignedIn) => {
            if (isSignedIn) {
                return this.fetchGoogleContacts()
            } else {
                return this.googleLogin().then(() => {
                    return this.fetchGoogleContacts()
                })
            }
        })
    },
    fetchGoogleContacts() {
        return vgapi.$gapi.getGapiClient().then((gapi) => {
            return gapi.client.people.people.connections
                .list({
                    resourceName: 'people/me',
                    personFields: 'names,emailAddresses,photos',
                })
                .then((response) => {
                    return response
                })
        })
    },
}
